import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { transparentize } from 'utils/color';
import media from 'components/mixins/media';

export const DefaultBgHelperContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const HelperSvg = styled.svg`
  position: absolute;
`;

export function CourseInfoDefaultBgHelper({
  className,
  theme,
  isStroked,
  isFilled,
  fillOpacity,
  strokeOpacity
}) {
  return (
    <HelperSvg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="276"
      height="305"
      viewBox="0 0 276 305"
    >
      <path
        fill={isFilled ? transparentize(theme.colors.coverBgOverlayTextColor, fillOpacity) : 'none'}
        stroke={
          isStroked ? transparentize(theme.colors.coverBgOverlayTextColor, strokeOpacity) : 'none'
        }
        d="M204.82 299.261c-75.115 26.93-231.275-65.08-199.648-166.066C36.8 32.21 153.425-26.138 216.68 14.256c63.254 40.394 96.113 246.295-11.86 285.005z"
      />
    </HelperSvg>
  );
}

CourseInfoDefaultBgHelper.propTypes = {
  isFilled: PropTypes.bool,
  isStroked: PropTypes.bool,
  fillOpacity: PropTypes.number,
  strokeOpacity: PropTypes.number,
  theme: PropTypes.object,
  className: PropTypes.string
};

CourseInfoDefaultBgHelper.defaultProps = {
  fillOpacity: 1,
  strokeOpacity: 1
};

export const TopLeftCornerElement = styled(CourseInfoDefaultBgHelper)`
  top: -98px;
  left: -127px;
`;
export const BottomRightCornerSwitchableElement = styled(CourseInfoDefaultBgHelper)`
  right: -31px;
  bottom: -150px;
  ${media.tablet`
    right: 75px;
    bottom: -200px;
  `};
  ${media.mobile`
    display: none;
  `};
`;
export const BottomRightCornerElement = styled(CourseInfoDefaultBgHelper)`
  right: -200px;
  bottom: -22px;
  ${media.tablet`
    right: -93px;
    bottom: -102px;
  `};
  ${media.mobile`
    right: -190px;
    bottom: -190px;
  `};
`;

export function DefaultBgHelper({ theme }) {
  return (
    <DefaultBgHelperContainer>
      <TopLeftCornerElement theme={theme} isFilled fillOpacity={0.3} />
      <BottomRightCornerElement theme={theme} isStroked strokeOpacity={0.8} />
      <BottomRightCornerSwitchableElement theme={theme} isStroked strokeOpacity={0.8} />
    </DefaultBgHelperContainer>
  );
}

DefaultBgHelper.propTypes = {
  theme: PropTypes.object
};

export default withTheme(DefaultBgHelper);
